import { JTLCredentialsStatusEnum } from '@/core/enums';
import { CreateJTLCredentialsDTO, JTLCredentials } from '@/core/types';
import { useTranslation } from 'react-i18next';

interface Props {
  credentials: JTLCredentials | CreateJTLCredentialsDTO | undefined;
  className: string;
}

export const JTLStatus = ({ credentials, className = '' }: Props) => {
  const { t } = useTranslation();

  if (!credentials) return null;

  const renderStatus = () => {
    switch (credentials.status) {
      case JTLCredentialsStatusEnum.ConnectionEstablished:
        return <div>{t('Connection established')}</div>;
      case JTLCredentialsStatusEnum.ConnectionWithoutFiling:
        return <div>{t('Connection established')}</div>;
      case JTLCredentialsStatusEnum.ConnectionLost:
        return (
          <div>
            {t('Connection lost. Please check the JTL connector for details.')}
          </div>
        );
      case JTLCredentialsStatusEnum.WaitingForSync:
        return (
          <div>
            <span>{t('Connection established')}. </span>
            <span>
              {t('Synchronization status will be confirmed within 4 hours.')}
            </span>
          </div>
        );
      default:
        return (
          <div>
            {t(
              'Credentials generated, but connection is not yet established. Open the JTL connector, then enter the Access ID and Secret Key from below to connect.'
            )}
          </div>
        );
    }
  };

  return <div className={className}>{renderStatus()}</div>;
};
